import { useSelector } from 'react-redux';

import { AppState } from '../../app.types';
import { User } from '@api';

export function useSelectorUsername () {
    return useSelector<AppState, string | null>((state: AppState) => {
        const userInfo = state.userProfiles.data?.user || null;

        if (userInfo !== null) {
            return `${userInfo?.firstName} ${userInfo?.lastName?.charAt(0)}.`;
        }

        return userInfo;
    });
}

export function useSelectorUserProfile () {
    return useSelector<AppState, User | null>((state: AppState) => {
        const userInfo = state.userProfiles.data?.user || null;

        return userInfo;
    });
}

export function useSelectorUserProfileType () {
    return useSelector<AppState, number | null>((state: AppState) => state.userProfiles.data?.user?.userProfileType || null);
}
